import React, { useState } from 'react';
import styles from './Blog.module.css';
import { Toaster, toast } from 'react-hot-toast';
import imge from '../BlogPosts/Rectangle_4449.webp';
import imge1 from '../BlogPosts/Rectangle_4448.webp';
import imge2 from '../BlogPosts/Rectangle_4455.webp';
import imge3 from '../BlogPosts/Rectangle_4456.webp';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "We give ourselves an Italian taste",
      date: "July 01, 2022",
      author: "My ferry",
      comments: 3,
      image: imge,
      description: "Breakfast is one of the most significant and essential meals of the day. We get enough energy from breakfast to start our day with a positive attitude.",
      content: `The purpose is not what someone would use breakers; they like to have a nice cup of coffee or tea finding an opportunity day.

To me, Italian breakfast is the half of my day. Feel blessed are strong and full for the span of the day.`,
      quote: {
        author: "Jean ferry",
        text: "A good restaurant is like a vacation; it transports you, and it becomes a lot more than just about the food."
      },
      benefits: [
        "You can confirm your seat beforehand at the restaurant.",
        "You can plan according to the reservation time",
        "You can reduce the chances of halting your special occasions"
      ],
      tags: ["Food", "Salad", "Blog"]
    },
    {
      id: 2,
      title: "Salads? - Are also original...",
      date: "July 01, 2022",
      author: "My ferry",
      comments: 2,
      image: imge1,
      description: "Fresh and healthy salads made with love and care, bringing the authentic Italian taste to your plate.",
      content: `Salads in Italian cuisine are not just side dishes, they are a celebration of fresh ingredients and simple yet elegant preparations.

From classic Caesar to innovative Mediterranean combinations, every salad tells a story.`,
      quote: {
        author: "Jean ferry",
        text: "A good restaurant is like a vacation; it transports you, and it becomes a lot more than just about the food."
      },
      benefits: [
        "Fresh ingredients sourced daily",
        "Authentic Italian dressings",
        "Perfect for any meal time"
      ],
      tags: ["Food", "Salad", "Health"]
    },
    {
      id: 3,
      title: "Fresh Exotic Burger, Have Taste",
      date: "July 01, 2022",
      author: "My ferry",
      comments: 5,
      image: imge2,
      description: "Experience the perfect blend of Italian flavors in our signature burgers crafted with premium ingredients.",
      content: `Our burgers are a fusion of Italian tradition and modern culinary innovation. Each bite is an explosion of flavors.

Made with fresh, locally sourced ingredients and our secret Italian spices.`,
      quote: {
        author: "Jean ferry",
        text: "A good restaurant is like a vacation; it transports you, and it becomes a lot more than just about the food."
      },
      benefits: [
        "Premium quality meat",
        "Freshly baked buns daily",
        "Unique Italian flavor profiles"
      ],
      tags: ["Food", "Burger", "Italian"]
    },
    {
      id: 4,
      title: "Italian Mafia Taste",
      date: "July 01, 2022",
      author: "My ferry",
      comments: 4,
      image: imge3,
      description: "Discover the bold and authentic flavors that define true Italian cuisine with our signature dishes.",
      content: `The essence of Italian cooking lies in its simplicity and the quality of ingredients. Our chefs bring generations of family recipes to your table.

Every dish is prepared with passion and dedication to maintain the authentic Italian taste.`,
      quote: {
        author: "Jean ferry",
        text: "A good restaurant is like a vacation; it transports you, and it becomes a lot more than just about the food."
      },
      benefits: [
        "Traditional family recipes",
        "Authentic Italian ingredients",
        "Cooked with passion and expertise"
      ],
      tags: ["Food", "Italian", "Authentic"]
    }
  ];

  const [selectedPost, setSelectedPost] = useState(blogPosts[0]);
  const [commentAuthor, setCommentAuthor] = useState('');
  const [commentEmail, setCommentEmail] = useState('');
  const [commentText, setCommentText] = useState('');
  const [comments, setComments] = useState([
    { id: 1, author: "aaaa", date: "Jun 28, 2022", text: "seasaaaa" },
    { id: 2, author: "Latisha", date: "Jun 13, 2022", text: "Thank with retained Cheese in the one thing. I could eat corn and craft again." },
    { id: 3, author: "Latisha", date: "Jun 03, 2022", text: "Scelerisque libero scelerisque I capitalize your portable, even in supply you offices takeaout credit aired lot and seduction not of personalisable surde, curiam layout decor tot sempre." }
  ]);

//   const categories = [
//     { name: 'breakfast', count: 4 },
//     { name: 'dinner', count: 7 },
//     { name: 'drinks', count: 3 },
//     { name: 'lunch', count: 5 },
//     { name: 'salads', count: 2 },
//     { name: 'special', count: 6 }
//   ];

  const handleCommentSubmit = (e) => {
    e.preventDefault();

    if (!commentText.trim() || !commentAuthor.trim()) {
      toast.error('Please fill in your name and comment!');
      return;
    }

    const newComment = {
      id: comments.length + 1,
      author: commentAuthor,
      date: new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }),
      text: commentText
    };

    setComments([newComment, ...comments]);
    toast.success('Comment added successfully!');
    setCommentAuthor('');
    setCommentEmail('');
    setCommentText('');
  };

  return (
    <div className={styles.container}>
      {/* Toaster Component */}
      <Toaster position="top-right" reverseOrder={false} />

      <div className={styles.content}>
        {/* Main Content */}
        <div className={styles.mainContent}>
          <h1 className={styles.mainTitle}>We give ourselves an Italian taste</h1>

          <div className={styles.featuredImage}>
            <img src={selectedPost.image} alt={selectedPost.title} className={styles.mainImage} />
          </div>

          <div className={styles.postMeta}>
            <span className={styles.metaItem}><a href="#" className={styles.link}>{selectedPost.date}</a></span>
            <span className={styles.metaItem}>By {selectedPost.author}</span>
            <span className={styles.metaItem}>{selectedPost.comments} Comments</span>
          </div>

          <div className={styles.postDescription}>
            <strong>{selectedPost.description}</strong>
          </div>

          <div className={styles.postContent}>
            {selectedPost.content.split('\n\n').map((paragraph, index) => (
              <p key={index} className={styles.paragraph}>{paragraph}</p>
            ))}
          </div>

          <div className={styles.restaurantImages}>
            <img src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&h=300&fit=crop" alt="Restaurant interior" className={styles.gridImage} />
            <img src="https://images.unsplash.com/photo-1559339352-11d035aa65de?w=400&h=300&fit=crop" alt="Restaurant seating" className={styles.gridImage} />
          </div>

          <div className={styles.imageCaption}>
            The best time to go out. According to Korea, WINNING IT JUST ME or another person always you to give yourself more relaxing. Unique headspace.
          </div>

          <div className={styles.quoteBox}>
            <p className={styles.quoteAuthor}>{selectedPost.quote.author}</p>
            <p className={styles.quoteText}>"{selectedPost.quote.text}"</p>
          </div>

          <h2 className={styles.sectionTitle}>Big Benefit When Reservation</h2>

          <p className={styles.sectionIntro}>
            When you reserve a seat, you do not have to worry about where you will eat the space after you reach the restaurant or not. You finally exactly when to go there and enjoy your favorite cuisines.
          </p>

          <ul className={styles.benefitsList}>
            {selectedPost.benefits.map((benefit, index) => (
              <li key={index} className={styles.benefitItem}>{benefit}</li>
            ))}
          </ul>

          <p className={styles.closingText}>
            That immediately brought to mind one of my fondest memories, involving my daughter when she was just a toddler of one.
          </p>

          <div className={styles.tags}>
            {selectedPost.tags.map((tag, index) => (
              <span key={index} className={styles.tag}>{tag}</span>
            ))}
          </div>

          {/* Comments Section */}
          <div className={styles.commentsSection}>
            <h3 className={styles.commentsTitle}>{comments.length} comments</h3>
            {comments.map((comment) => (
              <div key={comment.id} className={styles.comment}>
                <div className={styles.commentAvatar}>
                  <span className={styles.avatarIcon}>👤</span>
                </div>
                <div className={styles.commentContent}>
                  <div className={styles.commentHeader}>
                    <span className={styles.commentAuthor}>{comment.author}</span>
                    <span className={styles.commentDate}>{comment.date}</span>
                  </div>
                  <p className={styles.commentText}>{comment.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Comment Form */}
          <div className={styles.commentFormSection}>
            <h3 className={styles.formTitle}>Leave A Comment</h3>
            <div>
              <textarea
                className={styles.commentTextarea}
                placeholder="Leave a Comment..."
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              />
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Author</label>
                  <input
                    type="text"
                    className={styles.input}
                    placeholder="Your Name"
                    value={commentAuthor}
                    onChange={(e) => setCommentAuthor(e.target.value)}
                  />
                </div>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Email</label>
                  <input
                    type="email"
                    className={styles.input}
                    placeholder="Email address"
                    value={commentEmail}
                    onChange={(e) => setCommentEmail(e.target.value)}
                  />
                </div>
              </div>
              <button onClick={handleCommentSubmit} className={styles.submitButton}>
                Post comment
              </button>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className={styles.sidebar}>
          <div className={styles.latestPosts}>
            <h3 className={styles.sidebarTitle}>Latest Post</h3>
            {blogPosts.map((post) => (
              <div
                key={post.id}
                className={`${styles.postItem} ${selectedPost.id === post.id ? styles.active : ''}`}
                onClick={() => setSelectedPost(post)}
              >
                <img src={post.image} alt={post.title} className={styles.postItemImage} />
                <div className={styles.postInfo}>
                  <span className={styles.postDateSmall}>{post.date}</span>
                  <h4 className={styles.postTitleSmall}>{post.title}</h4>
                </div>
              </div>
            ))}
          </div>

        
        </div>
      </div>
    </div>
  );
};

export default Blog;